jQuery(".amplia-testo__btn").on("click", function() {
    const content = jQuery(this)
      .parent()
      .find(".amplia-testo__text");
  
    const className = "amplia-testo__text--open";
  
    if (content.hasClass(className)) {
        content
            .removeClass(className)
            .slideUp();
        $(this)
            .closest('div')
            .find(".amplia-testo__btn svg")
            .css("transform", "initial");
    } else {
        content
            .addClass(className)
            .slideDown();
        $(this)
            .closest('div')
            .find(".amplia-testo__btn svg")
            .css("transform", "rotate(180deg)");
    }
  });
  